// Login.js

import React, { Component } from 'react';

class Login extends Component {
  render() {
    return (
      <div className={'alert alert-success'}>
      Thank you for registering.  An email has been sent to you to confirm your address.
    </div>
    );
  }
}

export default Login;


// WEBPACK FOOTER //
// ./src/components/RegistrationSuccess.js